import { RouteObject } from "react-router-dom";

import { ADMIN_ROUTES } from "../../routes";

import { AdminOverviewRedirect } from "./AdminOverviewRedirect";

export const AdminRoutes: RouteObject[] = [
  {
    path: ADMIN_ROUTES.AdminOverview,
    element: <AdminOverviewRedirect />,
  },
  {
    path: ADMIN_ROUTES.AdminOrgs,
    lazy: async () => {
      const { AdminOverviewRoute } =
        await import("@src/features/admin/pages/overview/AdminOverview.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.AdminOrgs}
            adminOnly={true}
            isEnabled={() => true}
            children={AdminOverviewRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.DemoStoreManagement,
    lazy: async () => {
      const { DemoStoreManagementRoute } =
        await import("@src/features/admin/pages/demoStores/DemoStoreManagement.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.DemoStoreManagement}
            adminOnly={true}
            isEnabled={() => true}
            children={DemoStoreManagementRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.Agencies,
    lazy: async () => {
      const { AgenciesRoute } =
        await import("@src/features/admin/pages/agencies/Agencies.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.Agencies}
            adminOnly={true}
            isEnabled={() => true}
            children={AgenciesRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.Regression,
    lazy: async () => {
      const { RegressionRoute } =
        await import("@src/features/admin/pages/regression/Regression.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.Regression}
            adminOnly={true}
            isEnabled={() => true}
            children={RegressionRoute}
          />
        ),
      };
    },
  },

  {
    path: ADMIN_ROUTES.SlackIntegrations,
    lazy: async () => {
      const { SlackIntegrationsRoute } =
        await import("@src/features/admin/pages/slackIntegrations/SlackIntegrations.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.SlackIntegrations}
            adminOnly={true}
            isEnabled={() => true}
            children={SlackIntegrationsRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.FeatureFlags,
    lazy: async () => {
      const { FeatureFlagsRoute } =
        await import("@src/features/admin/pages/featureFlags/FeatureFlags.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.FeatureFlags}
            adminOnly={true}
            isEnabled={() => true}
            children={FeatureFlagsRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.SlackIntegrationDetail,
    lazy: async () => {
      const { SlackIntegrationDetailRoute } =
        await import("@src/features/admin/pages/slackIntegrations/SlackIntegrationDetail.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.SlackIntegrationDetail}
            adminOnly={true}
            isEnabled={() => true}
            children={SlackIntegrationDetailRoute}
          />
        ),
      };
    },
  },
];
